import { render, staticRenderFns } from "./ContactsFilter.vue?vue&type=template&id=4631eb6c&scoped=true&lang=pug&"
import script from "./ContactsFilter.vue?vue&type=script&lang=js&"
export * from "./ContactsFilter.vue?vue&type=script&lang=js&"
import style0 from "./ContactsFilter.vue?vue&type=style&index=0&id=4631eb6c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4631eb6c",
  null
  
)

export default component.exports